import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectHoldableItemEntities } from '../EntitiesSelector';

const getHoldableItems = state => state.getIn(['bibs', 'holdableItems'], Immutable.Map());

export const selectHoldableItemsForCurrentBib = createSelector(
  [getHoldableItems, selectHoldableItemEntities],
  (holdableItems, holdableItemEntities) =>
    holdableItems.get('items', Immutable.List()).map(id => holdableItemEntities.get(id))
);

export default {
  selectHoldableItemsForCurrentBib
};
